export default __webpack_public_path__ + "static/default_ln-71e847ce477484d3791631892fea1091.gif";